import { Banner } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export type SandboxBannerHandler = {
  getHeight: () => number;
};

type SandboxBannerProps = {
  hideOnDesktop?: boolean;
};

const SandboxBanner = forwardRef<SandboxBannerHandler, SandboxBannerProps>(({ hideOnDesktop }, ref) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const getHeight = () => containerRef.current?.clientHeight ?? 0;
  const { t } = useTranslation('idv', {
    keyPrefix: 'global.components.layout',
  });

  useImperativeHandle(ref, () => ({
    getHeight,
  }));

  return (
    <div
      ref={containerRef}
      className={cx('border-b border-solid border-tertiary z-[5]', hideOnDesktop && 'md:hidden')}
      data-testid="sandbox-banner"
    >
      <Banner variant="warning">{t($ => $['sandbox-banner'])}</Banner>
    </div>
  );
});

export default SandboxBanner;
